
import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthGroup from '@/logic/auth/AuthGroup';

@Component
export default class DashboardBlock extends Vue {
  @Prop(Object)
  block!: any;

  get link(): string | undefined {
    return this.block.link ? this.block.link : undefined;
  }

  get linkTarget(): string | undefined {
    if (this.block.multinational) {
      return '_self';
    }

    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    return this.link && this.link.startsWith(baseUrl) ? '_self' : '_blank';
  }

  isVisibleToUser(): boolean {
    const memberOf = this.$store.getters['auth/memberOf'];
    const direct =
      this.block.direct === true &&
      (memberOf('direct-customers') || memberOf('end-users'));
    const indirect =
      this.block.indirect === true && memberOf('indirect-customers');
    const multinational =
      this.block.multinational === true && memberOf(AuthGroup.Multinational);

    return direct || indirect || multinational;
  }
}
